import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyB846qeJgE8-FaXeFvIQq6p4wHzO6m1wB8",
  authDomain: "bestellsystem-81e5f.firebaseapp.com",
  projectId: "bestellsystem-81e5f",
  storageBucket: "bestellsystem-81e5f.firebasestorage.app",
  messagingSenderId: "238927687544",
  appId: "1:238927687544:web:d906d8b18bf4809420a28d"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore()
const auth = getAuth()

export { app, db, auth }